export const VIEWER_CAPABLE_ROLES = ['VIEWER', 'RESIDENT_AMBASSADOR']

export const isViewerCapable = (role) => VIEWER_CAPABLE_ROLES.includes(role)